import { render } from "./LXSettingsForm.vue?vue&type=template&id=3e522399&scoped=true"
import script from "./LXSettingsForm.vue?vue&type=script&lang=js"
export * from "./LXSettingsForm.vue?vue&type=script&lang=js"

import "./LXSettingsForm.vue?vue&type=style&index=0&id=3e522399&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e522399"

export default script